module.exports = __webpack_public_path__ + "img/speed.b85b5d1.svg";